import { Component, computed, input, output, signal } from '@angular/core';

import { RatingScalePresentation } from '@core/candidate-evaluation-settings-types';
import type { AggregatedEvaluationsReviewerEvaluation } from '@core/evaluations-types';
import { TranslatePipe } from '@core/i18n-legacy';
import { Theme } from '@core/theme-util';
import { TimeAgoPipe } from '@core/time-legacy';
import {
  AvatarComponent,
  BadgeComponent,
  BoxComponent,
  ButtonComponent,
  DividerComponent,
  IconButtonComponent,
  IconComponent,
} from '@core/user-interface-legacy';

import { EvaluationRatingScoreComponent } from '../evaluation-rating-score/evaluation-rating-score.component';
import { CandidateOfferEvaluationReviewerResultPreviewComponent } from './candidate-offer-evaluation-reviewer-result-preview/candidate-offer-evaluation-reviewer-result-preview.component';

@Component({
  selector: 'rt-candidate-offer-evaluation-reviewer-result',
  templateUrl: './candidate-offer-evaluation-reviewer-result.component.html',
  styleUrl: './candidate-offer-evaluation-reviewer-result.component.less',
  imports: [
    AvatarComponent,
    BadgeComponent,
    BoxComponent,
    ButtonComponent,
    CandidateOfferEvaluationReviewerResultPreviewComponent,
    DividerComponent,
    EvaluationRatingScoreComponent,
    IconButtonComponent,
    IconComponent,
    TimeAgoPipe,
    TranslatePipe,
  ],
})
export class CandidateOfferEvaluationReviewerResultComponent {
  public evaluation = input.required<AggregatedEvaluationsReviewerEvaluation>();

  public theme = input<Theme | null>(null);

  public useProsemirror = input(false);

  public edit = output<AggregatedEvaluationsReviewerEvaluation>();

  public delete = output<AggregatedEvaluationsReviewerEvaluation>();

  protected isPreviewOpen = signal(false);

  protected showScoreIcon = computed(
    () => this.evaluation().ratingScale?.presentation !== RatingScalePresentation.Numeric,
  );

  protected roleBadges = computed(() => {
    const reviewer = this.evaluation().reviewer;
    const badges: string[] = [];

    if (reviewer.type === 'guest') {
      badges.push('app.common.guest');
    }

    if (reviewer.isRecruiter) {
      badges.push('app.common.recruiter');
    }

    if (reviewer.isHiringManager) {
      badges.push('app.common.hiring_manager');
    }

    return badges;
  });

  protected isEdited = computed(() => this.evaluation().updatedAt !== this.evaluation().createdAt);

  protected togglePreview(): void {
    this.isPreviewOpen.update(open => !open);
  }
}
